import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialog) = $event)),
    title: _ctx.companyType === 'CUSTOMER' ? 'Client' : 'Fournisseur',
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close())),
    width: "800px"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          (_ctx.thirdPartyCompanyAlreadyDefined)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    block: "",
                    onClick: _ctx.validate,
                    loading: _ctx.loading,
                    size: "x-large"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Retirer ")
                    ])),
                    _: 1
                  }, 8, ["onClick", "loading"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: _ctx.thirdPartyCompanyAlreadyDefined ? 6 : 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                block: "",
                onClick: _ctx.validate,
                loading: _ctx.loading,
                disabled: !_ctx.thirdPartyCompany,
                size: "x-large"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Valider")
                ])),
                _: 1
              }, 8, ["onClick", "loading", "disabled"])
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.activateFreeTag)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            "no-gutters": "",
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_FreeTag, {
                    companyTags: _ctx.allCompanyTags,
                    company: _ctx.selectedCompany,
                    createIfMissing: true,
                    onOnTagsChanged: _ctx.onTagsChanged
                  }, null, 8, ["companyTags", "company", "onOnTagsChanged"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_CompaniesTable, {
        showGenericCompany: _ctx.companyType === 'SUPPLIER',
        showSupplierCompanies: _ctx.companyType === 'SUPPLIER',
        showConsumerCompany: _ctx.companyType === 'CUSTOMER',
        showCustomerCompanies: _ctx.companyType === 'CUSTOMER',
        showExistingCompanies: false,
        parentCompanyId: _ctx.companyId,
        company: _ctx.companyName,
        wizardMode: true,
        onSelectCompany: _ctx.setThirdPartyCompany
      }, null, 8, ["showGenericCompany", "showSupplierCompanies", "showConsumerCompany", "showCustomerCompanies", "parentCompanyId", "company", "onSelectCompany"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}